module.exports = __webpack_public_path__ + "static/media/mc_symbol.543bc93b.svg";